import { render } from "./WohnungStep6.vue?vue&type=template&id=7c3f8ce1&scoped=true"
import script from "./WohnungStep6.vue?vue&type=script&lang=js"
export * from "./WohnungStep6.vue?vue&type=script&lang=js"

import "./WohnungStep6.vue?vue&type=style&index=0&id=7c3f8ce1&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3f8ce1"]])

export default __exports__